import {
  parsePhoneNumberFromString,
  type CountryCode,
} from "libphonenumber-js";
import { COUNTRIES } from "@components/common/PhoneInputCountries";

export function formatE164(
  country: CountryCode,
  nationalNumber: string,
): string {
  const digits = nationalNumber.replace(/\D/g, "");
  if (digits === "") {
    return "";
  }
  const parsed = parsePhoneNumberFromString(digits, country);
  if (parsed != null) {
    return parsed.format("E.164");
  }
  const entry = COUNTRIES.find((c) => c.code === country);
  if (entry != null) {
    return `${entry.dialCode}${digits}`;
  }
  return `+${digits}`;
}

export function parsePhone(
  e164: string,
): { country: CountryCode; nationalNumber: string } | null {
  if (e164 === "") {
    return null;
  }
  const parsed = parsePhoneNumberFromString(e164);
  if (parsed != null && parsed.country != null) {
    return {
      country: parsed.country,
      nationalNumber: parsed.nationalNumber,
    };
  }
  return null;
}

export function formatPhoneDisplay(value: string): string {
  if (value === "") {
    return "";
  }
  const parsed = parsePhoneNumberFromString(value);
  if (parsed != null) {
    return parsed.formatInternational();
  }
  return value;
}

export function isValidPhone(value: string): boolean {
  if (value === "") {
    return false;
  }
  const parsed = parsePhoneNumberFromString(value);
  if (parsed == null) {
    return false;
  }
  return parsed.isValid();
}
